import React, { useEffect } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Paper, Typography, Grid } from "@material-ui/core";

import { styles } from "./IpmaWeather.styles";
import { getMeteoData, selectMeteoData } from "../dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import IpmaWeatherForecastItem from "./components/IpmaWeatherForecastItem";

function IpmaWeather({ classes }) {
  const dispatch = useDispatch();
  const meteoData = useSelector(selectMeteoData);

  // console.log("meteoData: %o", meteoData);

  useEffect(() => {
    dispatch(getMeteoData());
    // eslint-disable-next-line
  }, []);
  return (
    <Paper className={classes.root}>
      <Grid container spacing={1} direction="column">
        <Grid item>
          <Typography variant="h5">{meteoData?.properties?.localEstacao}</Typography>
          <Typography variant="caption">Dados da última leitura (max 3h) da estação metereológica</Typography>
        </Grid>
        <Grid item>
          <Typography variant="caption" className={classes.lbl}>
            Vento
          </Typography>
          <Typography variant="body1">
            {meteoData?.properties?.intensidadeVentoKM}km/h ({meteoData?.properties?.descDirVento})
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="caption" className={classes.lbl}>
            Humidade
          </Typography>
          <Typography variant="body1">{meteoData?.properties?.humidade}%</Typography>
        </Grid>
        <Grid item>
          <Typography variant="caption" className={classes.lbl}>
            Temperatura
          </Typography>
          <Typography variant="body1">{meteoData?.properties?.temperatura}ºC</Typography>
        </Grid>
        <Grid item>
          {(meteoData?.forecast || []).map((item, i) => {
            return <IpmaWeatherForecastItem key={"forecast_" + i} forecast={item} />;
          })}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default withStyles(styles)(IpmaWeather);
